import * as types from './editionsActionTypes';
import firebaseApp from './../../utils/firebase/firebase';
import SingletonLibrary from '../../library/SingletonLibrary';

import {getAllArticleReactionsByEdition} from './../Article/articleActions';

export const setEditions = ( previous, current, next = [] ) => {
    return {
        type: types.SET_EDITIONS,
        previous, 
        next, 
        current
    };
};

export const setEditionsFailed = (errorMessage) => {
    return {
        type: types.SET_EDITIONS_FAILED,
        errorMessage
    };
};


export const getSpecificEditionStart = () => {
     return {
         type:types.RETRIEVE_SPECIFIC_EDITION_START,
         specificEditionRetrievalInProgress : true,
     }
}

export const getSpecificEditionSuccess = (previous, current, next = []) => {
    return {
        type:types.RETRIEVE_SPECIFIC_EDITION_SUCCESS,
        previous, 
        next, 
        current,
        specificEditionRetrieved : true,
        specificEditionRetrievalInProgress : false,
    };
}

export const getSpecificEditionFail = (errorMessage, errorCode) => {
    return {
        type:types.RETRIEVE_SPECIFIC_EDITION_FAIL,
        errorCode,
        errorMessage,
        specificEditionRetrievalInProgress : false,
    };
}

export function getSpecificEditionByDate(targetEditionDate, direction) {
    return (dispatch, getState) => {
       
        firebaseApp.auth().currentUser.getIdToken() 
            .then(function(fbIdToken) {
                   
                    dispatch(getSpecificEditionStart()); 
            
                    let editionPathDirection = '';    
                    if(parseInt(direction, 10) < 0 ){
                        editionPathDirection = 'previous';
                    }else if(parseInt(direction, 10) > 0 ){
                        editionPathDirection = 'next';
                    }

                    SingletonLibrary
                        .getAxiosInstance
                        .get('/edition/'+editionPathDirection+'/'+targetEditionDate, { headers:{'fbkm-access-token':fbIdToken}})
                        .then((result) => {
                            const response = ( result.error !== true && typeof result.data.response !== 'undefined' )?  
                                result.data.response : null ;
                            
                            if( response !== null ) {
                                
                                let newNext = [];
                                let newCurrent = {}; 
                                let newPrev = [];  

                                if(parseInt(direction, 10) < 0 ){
                                    
                                    newNext.push(getState().editions.current);
                                    newCurrent = getState().editions.previous.shift();
                                    newPrev.push(response);
                                    
                                }else if(parseInt(direction, 10) > 0 ){
                                    newNext.push(response);
                                    newCurrent =  getState().editions.next.shift();
                                    newPrev.push(getState().editions.current);
                                }
                                dispatch(getAllArticleReactionsByEdition(newCurrent.slug));
                                dispatch(getSpecificEditionSuccess(newPrev, newCurrent, newNext));
                            }
                        })
                        .catch((e) => {
                        
                            const errorCode = ( typeof e.response !== 'undefined' && e.response.status ) || 0;
                            const errorMessage = ( typeof e.response !== 'undefined' && e.response.statusText ) || 'Erreur inattendue';
                           
                            dispatch(getSpecificEditionFail(errorMessage, errorCode)); 
                        });
            });
    }
}

export function getSpecificEdition(date) {
  return (dispatch, getState) => {
       
    firebaseApp.auth().currentUser.getIdToken() 
        .then(function(fbIdToken) {
               
                dispatch(getSpecificEditionStart());

                SingletonLibrary
                    .getAxiosInstance
                    .get('/editions', { headers:{'fbkm-access-token':fbIdToken}})
                    .then((result) => {
                        const response = ( result.error !== true && typeof result.data.response !== 'undefined' )?  
                            result.data.response : null ;
                        
                        if( response !== null ) {
                            
                            let newNext = [];
                            let newCurrent = {}; 
                            let newPrev = []; 

                            for(var i=0; i<response.length; i++)
                            {
                              if(response[i].publication_date === date)
                              {
                                newCurrent = response[i];
                                newNext = i>0?[response[i-1]]:[];
                                newPrev = i < response.length?[response[i+1]]:[];
                              }
                            }

                            if(typeof newCurrent.slug !== 'undefined')
                            {
                              dispatch(getAllArticleReactionsByEdition(newCurrent.slug));
                              dispatch(getSpecificEditionSuccess(newPrev, newCurrent, newNext));
                            }
                            else{
                              dispatch(getSpecificEditionFail("edition not found", 404));
                            }

                            
                        }
                        else{
                          dispatch(getSpecificEditionFail("unexpected error", 500));
                        }

                    })
                    .catch((e) => {

                        const errorCode = ( typeof e.response !== 'undefined' && e.response.status ) || 0;
                        const errorMessage = ( typeof e.response !== 'undefined' && e.response.statusText ) || 'Erreur inattendue';
                       
                        dispatch(getSpecificEditionFail(errorMessage, errorCode)); 
                    });
        });
}
}

export const showBlockedChatPopup = () => {
  return {
      type: types.SHOW_BLOCKED_CHAT_POPUP
  }
}

export const hideBlockedChatPopup = () => {
  return {
      type: types.HIDE_BLOCKED_CHAT_POPUP
  }
}


// WEBPACK FOOTER //
// ./src/components/Editions/editionsActions.js